import React from "react";
import * as CHQ from "chq";

import { StoryTrendLink } from "app/links";
import { Trans } from "app/utils";
import NotificationBody from "./NotificationBody";

type VideoNotificationProps = {
  notification: CHQ.NotificationVideoStoryQuestionUpdated;
  tabIndex?: number;
};

const VideoStoryQuestionUpdatedNotification: React.FC<VideoNotificationProps> = ({
  notification: { entity }, tabIndex
}) => (
  <NotificationBody actor={entity?.user}>
    Your
    {" "}
    <Trans>
      <StoryTrendLink storyQuestion={entity} tabIndex={tabIndex || 0}>
        story trend page
      </StoryTrendLink> was updated successfully
    </Trans>
    <br />
    {entity?.question}
  </NotificationBody>
);

export default VideoStoryQuestionUpdatedNotification;
